import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const BankingGridLayout = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '0.5rem',
  gridTemplateColumns: '1fr',

  [theme.breakpoints.up('md')]: {
    gap: '0.75rem',
    gridTemplateColumns: '6fr 6fr'
  }
}));
